<template>
    <div id="contact-history" class="container-fluid p-0">
        <div class="row">
            <div class="col">
                <div class="row align-items-baseline">
                    <ul class="page-tabs ml-3">
                        <li
                            class="page-tab active"
                            @click="selectedHistory = 'sms'"
                            v-if="typeof contact.attributes['facebook-id'] === 'undefined' || contact.attributes['facebook-id'] === null">
                            <router-link :to="{ name: '' }" data-toggle="pill" data-target="#pills-sms">{{ $t('sms') }}</router-link>
                        </li>
                        <li class="page-tab active" @click="selectedHistory = 'facebook'"
                            v-else>
                            <router-link :to="{ name: '' }" data-toggle="pill" data-target="#pills-facebook">{{ $t('facebook') }}</router-link>
                        </li>
                    </ul>
                </div>
            </div>
            <a class="sidebar-arrow ml-auto d-none close-btn text-btn" href="#" @click="$emit('hideSidebar')" v-if="collapseSidebar">{{ $t('close') }} <font-awesome-icon :icon="['fas', 'angle-double-right']" /></a>
            <a class="sidebar-arrow ml-auto d-none open-btn text-btn" href="#" @click="$emit('showSidebar')" v-bind:class="{ fadeIn: !collapseSidebar }"><font-awesome-icon :icon="['fas', 'angle-double-left']" /></a>

        </div>
        <div class="contact-history-body d-flex align-items-start">
            <div class="contact-history-main flex-grow-1">
                <div class="tab-pane" id="pills-sms" v-if="typeof contact.attributes['facebook-id'] === 'undefined' || contact.attributes['facebook-id'] === null">
                    <div class="history-bg pb-3">
                        <sms-chat
                            :pageName="'Contact-history'"
                            :load-conversationless-messages="true"
                            v-on:conversationUpdated="updateSections()"
                        ></sms-chat>
                    </div>
                </div>
                <div class="tab-pane" id="pills-facebook" v-else>
                    <preloader-placeholder :loading="loading" :resultlength="contactInteractions.length" :type="'box'"></preloader-placeholder>
                    <div class="history-wrap">
                        <div class="history-bg pb-3">
                            <div v-for="interaction in contactInteractions" :key="interaction.id">
                                <facebook-message-box
                                    v-bind:interaction="interaction"
                                    v-if="interaction.attributes.category != 'post'"
                                    v-bind:activePageId="activePageId">
                                </facebook-message-box>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <slot name="sidebar"></slot>
        </div>
    </div>
</template>
<script>

// Components
import SmsChat              from '../../../connectors/sms/components/SmsChat.vue';
import FacebookMessageBox   from '../../../connectors/facebook/components/FacebookMessageBox.vue';
import PreloaderPlaceholder from '../PreloaderPlaceholder.vue';

// Import external libraries
import { mapState } from 'vuex';

export default {
    props: [
        'collapseSidebar',
        'contactInteractions',
        'activePageId',
        'loading',
        'singleContactAllInteractions'
    ],
    components: {
        FacebookMessageBox,
        PreloaderPlaceholder,
        SmsChat
    },

    data () {
        return { selectedHistory: '' };
    },

    computed: { ...mapState('core/contacts', { contact: 'single' }) }
};
</script>
